import { Component, DestroyRef, LOCALE_ID, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { environment } from '../environments/environment';
import { NgIf, registerLocaleData } from '@angular/common';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationSkipped, NavigationStart, Router, RouterOutlet } from '@angular/router';
import localeFr from '@angular/common/locales/fr';

// Services
import { AuthService } from 'src/app/_services';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

// Modals Module
import { ModalsModule } from 'src/app/all/_popup_modals/modals.module';
import { VersionCheckService } from './_services/version-check.service';
import { AgentIaComponent } from './all/agent-ia/agent-ia.component';

// Enregistrement des locales françaises
registerLocaleData(localeFr, 'fr');

declare var profitwell;
declare var Tawk_API: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
      MessageService,
      { provide: LOCALE_ID, useValue: 'fr-FR'}
    ],
    imports: [
        ToastModule,
        RouterOutlet,
        ModalsModule,
        NgIf,
        AgentIaComponent
    ]
})
export class AppComponent {
  agentOpened = false;
  get showAgentIa() { return this.authService.isArchitect() && /^\/architect(?:\/|$)/.test(this.router.url); }
  title = 'app';
  // Navigation en cours (téléchargement du code d'une page, gardes) : fine barre en haut de page, affichée
  // seulement au-delà de 150 ms pour ne pas clignoter sur les navigations rapides.
  public navigating = signal(false);
  private navigatingTimer: ReturnType<typeof setTimeout>;
  private destroyRef = inject(DestroyRef);
  public notificationsOptions = {
    position: ["bottom", "right"],
    timeOut: 5000,
    lastOnBottom: true,
    clickToClose:true,
    animate:"fromRight",
    showProgressBar:false
  }
  public alertsOptions={}
  public confirmationsOptions={}

  constructor(
    private authService:AuthService,
    private router: Router,
    public vc: VersionCheckService
  ){
    vc.start(60_000); 
    this.trackNavigation();
  }

  ngOnInit(): void {
    console.log("APP")
    this.authService.getUserLicence();
    this.emitToProfitwell();
    // when you're inside input number, and you scroll the value changes (this to disable it)
    this.diableInputNumberScrollChange();
    const currentUser = this.authService.currentUser || {};
    if (currentUser?.email) {
      Tawk_API.visitor = {
        name: currentUser.firstName + " " + currentUser.lastName,
        email: currentUser.email
      };
    }
  }
  private trackNavigation(){
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => {
      if (event instanceof NavigationStart) {
        clearTimeout(this.navigatingTimer);
        this.navigatingTimer = setTimeout(() => this.navigating.set(true), 150);
      } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError || event instanceof NavigationSkipped) {
        clearTimeout(this.navigatingTimer);
        this.navigating.set(false);
      }
    });
  }
  private emitToProfitwell(){
    let currentUser = this.authService.getAuthUser();
    if(environment.production && currentUser){
      profitwell('start', { 'user_email': currentUser["email"] });
    }
  }

  private diableInputNumberScrollChange(){
    document.addEventListener("wheel", function(event){
      const numberInput = (<HTMLInputElement>document.activeElement);
      if (numberInput.type === "number") {
        numberInput.blur();
      }
    });
  }

}
